import React from 'react';
import { useAuth } from 'react-oidc-context';
import { AppRoutes, LoginRedirectStorageKey } from '../../Constants';
import { Navigate } from 'react-router-dom';
import { Loading } from '@appkit4/react-components/loading';
import useToast from '../../helpers/useToast';
import useLocale from '../../locale/useLocale';

const LoginCallback = () => {
    const auth = useAuth();
    const showToast = useToast();
    const { l } = useLocale();

    if (auth.error) {
        showToast(
            l('_error'),
            l('_authenticationErrorPleaseLoginAgain'),
            'error'
        );
    }

    const returnRoute = window.sessionStorage.getItem(LoginRedirectStorageKey);

    return (
        <>
            {auth.isLoading ? (
                <Loading loadingType="circular" indeterminate compact={false} />
            ) : auth.error ? (
                <Navigate to={AppRoutes.LogoutPage} replace />
            ) : !auth.isAuthenticated ? (
                <Navigate to={AppRoutes.LandingPage} replace />
            ) : returnRoute ? (
                <Navigate to={returnRoute} />
            ) : (
                <Navigate to={AppRoutes.HomePage} replace />
            )}
        </>
    );
};

export default LoginCallback;
